export default __webpack_public_path__ + "static/media/image-cover.de2f71ad.jpg";